import { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  isAuthenticated: () => boolean;
  children: ReactNode;
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({
  isAuthenticated,
  children,
}) => {
  const location = useLocation();

  return isAuthenticated() ? (
    children
  ) : (
    <Navigate to="/" replace state={{ from: location }} />
  );
};

export default ProtectedRoute;
